import { createSection } from '../createSection'

/**
 * Label section for options
 *
 * @public
 */
export const boxLabel = createSection('label', 'span')
